import { connect } from 'react-redux'
import EventSetupRounds from '../../components/content/event_setup_rounds.jsx'
import { NotificationManager } from 'react-notifications'
import {
  setGenericData,
  updateRounds,
  editRound,
  toggleRoundSignup,
} from '../../actions/index'
import moment from 'moment'

// const mapStateToProps = (state) => {}

const mapDispatchToProps = (dispatch, ownProps) => {
  const { links, rounds, updatingData } = ownProps.content
  const internationalize = (key, data = null) => !window.I18n ? '' : window.I18n.t(key, data)

  const runRoundCreation = (data, infoMessage) => {
    NotificationManager.info(infoMessage)
    dispatch(setGenericData(ownProps.widgetId, [ 'updatingData', 'adding_round' ], true))
    dispatch(updateRounds(ownProps.widgetId, links.add_round.path, data, links.get_rounds.path))
      .then(() => {
        window.location.reload()
      })
      .catch(() => {
        dispatch(setGenericData(ownProps.widgetId, [ 'updatingData', 'adding_round' ], false))
      })
  }

  return {
    setData: (keys, value) => dispatch(setGenericData(ownProps.widgetId, keys, value)),
    addRounds: (dates) => runRoundCreation(
      { dates },
      internationalize('dashboard_plus.widgets.adding_rounds', { count: dates.length }),
    ),
    removeRound: (roundId) => {
      dispatch(setGenericData(ownProps.widgetId, [ 'updatingData', roundId ], 'removeRound'))
      dispatch(updateRounds(ownProps.widgetId, links.remove_round.path, { 'round_id': roundId }, links.get_rounds.path))
        .then(() => {
          window.location.reload()
        })
    },
    updateRoundDate: (roundId, newDate) => dispatch(editRound(
      ownProps.widgetId,
      decodeURI(links.update_play_at.path).replace(/{round_id}/g, roundId),
      {
        init_play_at: moment.unix(rounds.find(r => r.id === roundId).play_at).format('D MMMM Y'),
        play_at: moment.unix(newDate).format('D MMMM Y'),
      },
      [ rounds.findIndex(r => r.id === roundId), 'play_at' ],
      newDate)),
    updateRoundName: (roundId, name) => dispatch(editRound(
      ownProps.widgetId,
      decodeURI(links.update_round.path).replace(/{round_id}/g, roundId),
      {
        _method: 'put',
        round: {
          name: name,
        },
      },
      [ rounds.findIndex(r => r.id === roundId), 'name' ],
      name,
    )),
    toggleSignups: (roundId, skipNotifications = false) => {
      if (updatingData[roundId]) { return }

      dispatch(setGenericData(ownProps.widgetId, [ 'updatingData', roundId ], 'toggleSignups'))
      dispatch(toggleRoundSignup(
        ownProps.widgetId,
        decodeURI(links.toggle_signups.path).replace(/{round_id}/g, roundId),
        roundId,
        [ rounds.findIndex(r => r.id === roundId), 'signups_open', 'value' ],
        skipNotifications ? { skip_notifications: 1 } : {}))
    },
  }
}

export default connect(
  null,
  mapDispatchToProps,
)(EventSetupRounds)
